"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_PROPOSAL = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_PROPOSAL = (0, gql_1.gql)(`
   mutation CreateProposal($action: ProposalAction!, $description: String!, $catalog: ID!) {
   proposal(action: $action, description: $description, catalog: $catalog) {
      id
    }
   }
`);
